import { Box } from "@chakra-ui/layout";
import { Modal } from "antd";
import useTenantTipoEstruturaMoradia from "core/features/tenants/hooks/useTenantTipoEstruturaMoradia";
import { useLoading } from "components/GlobalLoading";
import FormCadastroUnidadeGeral from "./FormCadastroUnidadeGeral";

interface ModalCadastroUnidadeProps {
  isOpen: boolean;
  id?: string;
  tenantId: string;
  onClose: () => any;
  loadingSave?: boolean;
  onSaved: any;
}

function ModalCadastroUnidade({
  isOpen,
  id,
  tenantId,
  onClose,
  onSaved,
}: ModalCadastroUnidadeProps) {
  const { data: tenant, isLoading } = useTenantTipoEstruturaMoradia(tenantId!);

  useLoading(isLoading);

  return (
    <Modal width="800px" footer={null} visible={isOpen} onCancel={onClose}>
      <Box pt={4} pb={6}>
        {tenant ? (
          <FormCadastroUnidadeGeral
            tenantId={tenantId}
            id={id}
            tipoEstruturaMoradia={tenant.tipoEstruturaMoradia!}
            onClose={onClose}
            onSaved={onSaved}
          />
        ) : null}
      </Box>
    </Modal>
  );
}

export default ModalCadastroUnidade;
